import cn from 'classnames';
import React from 'react';

import styles from './AppLoader.module.scss';
import AppLoaderContent from './AppLoaderContent';

const LoaderCentered = ({className}) => <AppLoaderContent className={cn(styles.LoaderCentered, className)} />;

export default LoaderCentered;
